/**
 * Validação e envio AJAX do formulário de contato
 * 
 * @package trbx-theme
 * @since 1.0.0
 */
(function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
        const form = document.getElementById('contact-form');
        
        if (!form) {
            return;
        }

        const submitButton = document.getElementById('contact-form-submit');
        const submitText = document.getElementById('submit-text');
        const submitLoading = document.getElementById('submit-loading');
        
        // Limpar erros
        function clearErrors() {
            document.querySelectorAll('[id$="-error"]').forEach(el => {
                el.classList.add('hidden');
                el.textContent = '';
            });
            document.querySelectorAll('#contact-form input, #contact-form textarea, #contact-form select').forEach(el => {
                el.classList.remove('border-red-500', 'ring-red-500');
            });
        }
        
        // Mostrar erro em campo específico
        function showFieldError(fieldId, message) {
            const field = document.getElementById(fieldId);
            const errorSpan = document.getElementById(fieldId + '-error');
            
            if (field && errorSpan) {
                field.classList.add('border-red-500');
                field.classList.add('ring-red-500');
                errorSpan.textContent = message;
                errorSpan.classList.remove('hidden');
            }
        }
        
        // Mostrar toast de feedback
        function showToast(message, type) {
            // Remove toast existente se houver
            const existingToast = document.getElementById('contact-toast');
            if (existingToast) {
                existingToast.remove();
            }
            
            // Cria o toast
            const toast = document.createElement('div');
            toast.id = 'contact-toast';
            toast.className = `fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 max-w-md transform transition-all duration-300 translate-y-full opacity-0 ${
                type === 'success' 
                    ? 'bg-green-500 text-white' 
                    : 'bg-red-500 text-white'
            }`;
            
            const icon = type === 'success' 
                ? '<i class="fa-solid fa-check-circle text-2xl"></i>' 
                : '<i class="fa-solid fa-exclamation-circle text-2xl"></i>';
            
            toast.innerHTML = `
                ${icon}
                <span class="font-medium">${message}</span>
                <button onclick="this.parentElement.remove()" class="ml-2 hover:opacity-70 transition-opacity">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            `;
            
            document.body.appendChild(toast);
            
            // Anima a entrada
            requestAnimationFrame(() => {
                toast.classList.remove('translate-y-full', 'opacity-0');
                toast.classList.add('translate-y-0', 'opacity-100');
            });
            
            // Reset do formulário se sucesso
            if (type === 'success') {
                form.reset();
            }
            
            // Remove automaticamente após 6 segundos
            setTimeout(() => {
                toast.classList.remove('translate-y-0', 'opacity-100');
                toast.classList.add('translate-y-full', 'opacity-0');
                setTimeout(() => {
                    toast.remove();
                }, 300);
            }, 6000);
        }
        
        // Validação de email
        function isValidEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        }
        
        // Máscara de telefone
        function maskPhone(value) {
            value = value.replace(/\D/g, '');
            if (value.length <= 10) {
                value = value.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
            } else {
                value = value.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
            }
            return value;
        }
        
        // Aplicar máscara no telefone
        const telefoneField = document.getElementById('telefone');
        if (telefoneField) {
            telefoneField.addEventListener('input', function(e) {
                e.target.value = maskPhone(e.target.value);
            });
        }
        
        // Validação do formulário
        function validateForm() {
            clearErrors();
            let isValid = true;
            let firstErrorField = null;
            
            const nome = document.getElementById('nome').value.trim();
            const email = document.getElementById('email').value.trim();
            const telefone = document.getElementById('telefone').value.trim();
            const mensagem = document.getElementById('mensagem').value.trim();
            
            if (!nome) {
                showFieldError('nome', 'O nome é obrigatório.');
                if (!firstErrorField) firstErrorField = 'nome';
                isValid = false;
            } else if (nome.length < 3) {
                showFieldError('nome', 'O nome deve ter pelo menos 3 caracteres.');
                if (!firstErrorField) firstErrorField = 'nome';
                isValid = false;
            }
            
            if (!email) {
                showFieldError('email', 'O e-mail é obrigatório.');
                if (!firstErrorField) firstErrorField = 'email';
                isValid = false;
            } else if (!isValidEmail(email)) {
                showFieldError('email', 'Por favor, insira um e-mail válido.');
                if (!firstErrorField) firstErrorField = 'email';
                isValid = false;
            }
            
            if (!telefone) {
                showFieldError('telefone', 'O telefone é obrigatório.');
                if (!firstErrorField) firstErrorField = 'telefone';
                isValid = false;
            } else if (telefone.replace(/\D/g, '').length < 10) {
                showFieldError('telefone', 'O telefone deve ter pelo menos 10 dígitos.');
                if (!firstErrorField) firstErrorField = 'telefone';
                isValid = false;
            }
            
            if (!mensagem) {
                showFieldError('mensagem', 'A mensagem é obrigatória.');
                if (!firstErrorField) firstErrorField = 'mensagem';
                isValid = false;
            } else if (mensagem.length < 10) {
                showFieldError('mensagem', 'A mensagem deve ter pelo menos 10 caracteres.');
                if (!firstErrorField) firstErrorField = 'mensagem';
                isValid = false;
            }
            
            // Foca no primeiro campo com erro
            if (firstErrorField) {
                document.getElementById(firstErrorField).focus();
            }
            
            return isValid;
        }
        
        // Enviar formulário via AJAX
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            if (!validateForm()) {
                return;
            }
            
            // Desabilita botão e mostra loading
            submitButton.disabled = true;
            submitText.classList.add('hidden');
            submitLoading.classList.remove('hidden');
            clearErrors();
            
            // Prepara dados do formulário
            const formData = new FormData(form);
            
            // Obtém a URL do AJAX do objeto global ou usa o padrão
            const ajaxUrl = window.trbxAjax?.ajaxUrl || window.trbxContactForm?.ajaxUrl || '/wp-admin/admin-ajax.php';
            
            // Envia via AJAX
            fetch(ajaxUrl, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    showToast(data.data?.message || 'Mensagem enviada com sucesso! Entraremos em contato em breve.', 'success');
                } else {
                    showToast(data.data?.message || 'Erro ao enviar mensagem. Por favor, tente novamente.', 'error');
                    
                    // Mostra erros de campos específicos se houver
                    if (data.data?.errors) {
                        Object.keys(data.data.errors).forEach(fieldId => {
                            showFieldError(fieldId, data.data.errors[fieldId]);
                        });
                    }
                }
            })
            .catch(error => {
                showToast('Erro ao enviar mensagem. Por favor, tente novamente.', 'error');
                console.error('Contact Form Error:', error);
            })
            .finally(() => {
                // Reabilita botão
                submitButton.disabled = false;
                submitText.classList.remove('hidden');
                submitLoading.classList.add('hidden');
            });
        });
        
        // Validação em tempo real
        ['nome', 'email', 'telefone', 'mensagem'].forEach(fieldId => {
            const field = document.getElementById(fieldId);
            if (field) {
                field.addEventListener('blur', function() {
                    if (this.value.trim()) {
                        const errorSpan = document.getElementById(fieldId + '-error');
                        if (errorSpan) {
                            errorSpan.classList.add('hidden');
                            this.classList.remove('border-red-500', 'ring-red-500');
                        }
                    }
                });
                
                // Remove erro ao começar a digitar
                field.addEventListener('input', function() {
                    const errorSpan = document.getElementById(fieldId + '-error');
                    if (errorSpan && !errorSpan.classList.contains('hidden')) {
                        errorSpan.classList.add('hidden');
                        this.classList.remove('border-red-500', 'ring-red-500');
                    }
                });
            }
        });
    });
})();

